// --- Core ---
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
// --- SaniQ ---
import {OpeningHours} from "../../../models/OpeningHours";

interface OpeningHoursState {
  current: OpeningHours;
  lastUpdatedAt: Date;
}

const initialState: OpeningHoursState = {
  current: null,
  lastUpdatedAt: null
};

const openingHoursSlice = createSlice({
  // eslint-disable-next-line formatjs/no-literal-string-in-object
  name: 'openingHours',
  initialState,
  reducers: {
    showOpeningHoursCompleted(state, action: PayloadAction<OpeningHours>) {
      state.current = action.payload;
      state.lastUpdatedAt = new Date();
    }
  }
});

export const {showOpeningHoursCompleted} = openingHoursSlice.actions;

export default openingHoursSlice.reducer;
